<template>
  <div>
    <task-filter @change="onChange" />
    <!-- <div class="left-container">
      <noticeboard-list @selected="selected" />
    </div> -->
    <div class="right-container">
      <noticeboard-detail :filter-form="filterForm" />
      <br />
      <!-- <TaskHeat :filter-form="filterForm" /> -->
    </div>
  </div>
</template>

<script>
import NoticeboardDetail from '@/pages/data/components/NoticeboardDetail';
import TaskFilter from '@/pages/data/components/TaskFilter';

export default {
  components: { NoticeboardDetail, TaskFilter },
  data() {
    return {
      noticeboardId: parseInt(this.$route.query.noticeboardId) || null,
      filterForm: {
        begin_date: null,
        end_date: null,
        last_begin_date: null,
        last_online_date: null,
        team: null,
        objective: null
      }
    };
  },
  watch: {
    $route() {
      this.noticeboardId = parseInt(this.$route.query.noticeboardId) || null;
    }
  },
  methods: {
    selected(value) {
      this.$router.push({
        name: 'pages:data:noticeboard',
        query: {
          noticeboardId: value
        }
      });
    },
    onChange(checkedDate, checkedTeams, lastCheckedDate, objective) {
      this.filterForm = {
        begin_date: checkedDate[0].format('YYYY-MM-DD'),
        end_date: checkedDate[1].format('YYYY-MM-DD'),
        last_begin_date: lastCheckedDate[0].format('YYYY-MM-DD'),
        last_end_date: lastCheckedDate[1].format('YYYY-MM-DD'),
        teams: checkedTeams,
        objective: objective
      };
    }
  }
};
</script>
<style lang="less" scoped>
// .left-container {
//   width: 200px;
//   float: left;
//   margin-right: 16px;
// }
// .right-container {
//   width: calc(~'100% - 216px');
//   float: left;
// }
</style>
